import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { colors, fontSizes, media } from '../styles';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  size: PropTypes.string
};

const Label = props => {
  const { children, className, size = 'large', ...allProps } = props;

  return (
    <StyledLabel className={className} size={size} {...allProps}>
      {children}
    </StyledLabel>
  );
};

Label.propTypes = propTypes;

const StyledLabel = styled.p`
  text-transform: uppercase;
  font-weight: 900;
  color: ${colors.labelDefault};
  font-size: ${({ size }) => fontSizes.label[size].fontSize};
  line-height: ${({ size }) => fontSizes.label[size].lineHeight};
  letter-spacing: ${({ size }) => fontSizes.label[size].letterSpacing};
  margin-bottom: 8px;
  font-family: 'Lato Black', sans-serif;

  @media screen and (max-width: ${media.mediumBottom}) {
    font-size: ${({ size }) => fontSizes.label[size].mobile.fontSize};
    line-height: ${({ size }) => fontSizes.label[size].mobile.lineHeight};
    letter-spacing: ${({ size }) => fontSizes.label[size].mobile.letterSpacing};
  }
`;

export { Label };
